/* global $, ym */

// Обговорено решение навесить цели по индексу, в дальнейшем будет поставлена задача по рефакторингу
function targetsYmOnElements(arrayElements, arrayIdTargets) {
  if (arrayElements.length > 0 && arrayIdTargets.length > 0) {
    arrayElements.forEach((item, index) => {
      $(item).click(() => {
        if (index <= arrayIdTargets.length - 1 && typeof ym !== 'undefined' && !item.classList.contains('dropdown__item_active')) {
          ym(57872296, 'reachGoal', arrayIdTargets[index]);
        }
      });
    });
  }
}

function targetsYmOnLinksPage() {
  const tabsHeader = document.querySelectorAll('.header__tabs_small .tabs__item .tabs__link');
  const tabsHeaderTablet = document.querySelectorAll('.header-desktop .header__dropdown .dropdown__items .dropdown__item');
  const tabsFooter = document.querySelectorAll('.tabs_footer .tabs__item .tabs__link');
  const tabsFooterTablet = document.querySelectorAll('.footer .footer__dropdown .dropdown__item');
  const tabsFooterMobile = document.querySelectorAll('.footer .footer__items .footer__item-title');
  const arrayIdTargets = ['all_private_clients', 'all_online_store', 'all_business_partner', 'all_International_delivery', 'all_about'];

  targetsYmOnElements(tabsHeader, arrayIdTargets);
  targetsYmOnElements(tabsHeaderTablet, arrayIdTargets);
  targetsYmOnElements(tabsFooter, arrayIdTargets);
  targetsYmOnElements(tabsFooterTablet, arrayIdTargets);
  targetsYmOnElements(tabsFooterMobile, arrayIdTargets);
}

function targetsYmOnAdvantages(arrayIdTargets) {
  const advantagesLinks = $('.advantages .advantages__bottom .advantages__icons')[0];
  const advantagesAccordionLinks = $('.advantages .advantages__accordion .accordion__items')[0];

  if (advantagesLinks && advantagesLinks.children.length > 0) {
    targetsYmOnElements(advantagesLinks.children, arrayIdTargets);
  }

  if (advantagesAccordionLinks && advantagesAccordionLinks.children.length > 0) {
    targetsYmOnElements(advantagesAccordionLinks.children, arrayIdTargets);
  }
}

// Для использования данной функции нужно каждому переданному в массив
// элементу присвойтить атрибут data-ym с идентификатором цели
function addTargetsYmByAttribute(arrayElements, idCounter) {
  if (arrayElements.length > 0) {
    arrayElements.forEach((item) => {
      $(item).click(() => {
        if (item.dataset.ym && typeof idCounter === 'number' && typeof ym !== 'undefined') {
          ym(idCounter, 'reachGoal', item.dataset.ym);
        }
      });
    });
  }
}

function targetsYmOnAllElements() {
  const gaAll = document.querySelectorAll('[data-ym-tracking-id]');
  gaAll.forEach((gaItem) => {
    gaItem.addEventListener('click', (e) => {
      try {
        const {
          ymTrackingId, ymTargetName,
        } = e.target.dataset;
        ym(ymTrackingId, 'reachGoal', ymTargetName);
      } catch (err) {
        console.error(err);
      }
    });
  });
}
function targetsYmOnForm(form) {
  try {
    const {
      ymTrackingId, ymTargetName,
    } = form.dataset;
    if (!ymTrackingId) return;
    ym(ymTrackingId, 'reachGoal', ymTargetName);
  } catch (err) {
    console.error(err);
  }
}

function getYmCounterId() {
  const metrikaObj  = (window.Ya && (window.Ya.Metrika || window.Ya.Metrika2)) || null;
  return (metrikaObj && metrikaObj.counters && (metrikaObj.counters() || [0])[0].id);
}

function reachGoalYm(ymCounterNum, target) {
  const ymTrackingId = getYmCounterId() || ymCounterNum;
  try {
    ym(ymTrackingId, 'reachGoal', target);
  } catch (err) {
    console.error(err);
  }
}
export {
  targetsYmOnLinksPage,
  targetsYmOnElements,
  targetsYmOnAdvantages,
  addTargetsYmByAttribute,
  targetsYmOnAllElements,
  targetsYmOnForm,
  reachGoalYm,
};
